export default {
  fu: {
    filter_bar: {
      filter: "筛选",
      results: "个结果",
      clear: "清空条件",
      drawer_title: "筛选条件",
      cancel: "取消",
      search: "查询",
      select_all: "全选",
      more: "更多"
    },
    search_bar: {
      search: "搜索",
      adv_search: "高级搜索",
      ok: "确定",
      cancel: "取消",
      please_select: "请选择",
      please_input: "请输入",
      like: "包含",
      not_like: "不包含",
      in: "属于",
      not_in: "不属于",
      gt: "大于",
      ge: "大于等于",
      lt: "小于",
      le: "小于等于",
      eq: "等于",
      ne: "不等于",
      between: "之间",
      select_date: '选择日期',
      start_date: '开始日期',
      end_date: '结束日期',
      select_date_time: '选择日期时间',
      start_date_time: '开始日期时间',
      end_date_time: '结束日期时间',
      range_separator: "至",
      data_time_error: "开始日期不能大于结束日期",
      clean: "清空",
      refresh: "刷新",
    },
    table: {
      ok: "确定",
      reset: "重置",
      custom_table_fields: "自定义表格字段",
      custom_table_fields_desc: "固定字段不在选择范围，可拖拽自定义顺序",
      columns: "列表项",
      columns_title: "请选择列表中要展示的信息",
    },
    steps: {
      cancel: "取消",
      next: "下一步",
      prev: "上一步",
      finish: "完成",
    }
  }
}
